import { render, staticRenderFns } from "./index.vue?vue&type=template&id=afd42bc0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=afd42bc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd42bc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd42bc0')) {
      api.createRecord('afd42bc0', component.options)
    } else {
      api.reload('afd42bc0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=afd42bc0&scoped=true", function () {
      api.rerender('afd42bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/MapSetting/index.vue"
export default component.exports